import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams, Link as RouteLink, useLocation } from "react-router-dom"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { Helmet } from "react-helmet-async"
// MATERIAL UI
import { Box, Button, Container, Divider, Grid, Link, Typography, colors, useMediaQuery, useTheme } from "@mui/material"
// MUI ICONS
import LocationOnIcon from '@mui/icons-material/LocationOn'
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
// ACTIONS
import { getAuctionDetail } from "../../actions/auctionActions"
// COMPONENTS
import ShareButton from "../../components/utils/ShareButton"
import CarCard from "../../components/CarCard"
import AuctionDetailSkeleton from "../../components/djubliAuction/AuctionDetail/AuctionDetailSkeleton"
import AuctionCountdownCard from "../../components/djubliAuction/AuctionCountdownCard"
import ResultNotFound from "../../components/utils/ResultNotFound"
import DjubliDialog from "../../components/commons/DjubliDialog"
// CONSTANTS
import { fontPreset } from "../../constants/styling/fontStyleConstant"
import { captureEventGAWithAction, captureEventGAWithParams, captureEventPixel, captureEventToDB } from "../../constants/capture_event/captureEventConstant"
import { colorPalette } from "../../constants/styling/colorPalette"
import { changeDateFormat, changeTimeFormat } from "../../constants/utils/timeFormat"
import { AUCTION_BUY_TOKEN_STEP } from "../../constants/static_data/auctionDataType"

// SEARCH URL
// let searchQueryURL = []
// let sortURL = []
// let filterURL = []
// let pageURL = []
// FOR FILTER CHIPS
// let filterDesc = []

// const auctionNotes = [
//     "Calon Peserta Lelang wajib melakukan cek unit saat open house",
//     "Calon Peserta Lelang wajib melakukan cek fisik dan cek dokumen dengan sebaik baiknya karena kami menjual APA ADANYA",
//     "Pemenang Lelang dikenakan biaya administrasi sebesar Rp 3,000,000 dan 1,1% dari harga terbentuk",
//     "Pelunasan paling lambat 3 Hari Kerja setelah hari lelang selesai. Apabila tidak dilunasi sesuai jangka waktu pelunasan maka akan dianggap wanprestasi dan uang deposit akan hangus",
//     "Hari Sabtu, Minggu dan Hari Libur Nasional tidak dianggap hari kerja",
//     "Peserta Lelang yang tidak memenangkan lelang, uang deposit kembali tanpa potongan.",
//     "Uang deposit sebesar Rp 5,000,000 per unit",
//     "Semua transaksi baik deposit dan pelunasan hanya melalui rekening BCA 7140533500 an PT BINTANG PHOENIX SAKTI",
// ]

const AuctionDetail = () => {
    const params = useParams()
    const dispatch = useDispatch()

    
    const theme = useTheme()
    const downMediumScreen = useMediaQuery(theme.breakpoints.down("md"))
    
    const auctionDetailState = useSelector((state) => state.auctionScheduleDetail)
    
    const [openDialog, setOpenDialog] = useState(false)
    const handleOpenDialog = ({ title = "", body = "" }) => { 
        setOpenDialog(true)
        if(title !== "" && body !== "") {
            setDialogContent({ title: title, body: body })
        }
    }
    const handleCloseDialog = () => { setOpenDialog(false) }

    const [dialogContent, setDialogContent] = useState({ title: "Ikuti Lelang", body: "Kamu bisa mengikuti lelang menggunakan aplikasi DjuBli. Download Sekarang!" })
    
    const [openDialogBuyToken, setOpenDialogBuyToken] = useState(false)

    const handleOpenDialogBuyToken = () => { setOpenDialogBuyToken(true) }
    const handleCloseDialogBuyToken = () => { setOpenDialogBuyToken(false) }

    // const [openNotesDialog, setOpenNotesDialog] = useState(false)
    // const handleOpenNotesDialog = () => { setOpenNotesDialog(true) }
    // const handleCloseNotesDialog = () => { setOpenNotesDialog(false) }

    // SEARCH QUERY URL
    // const searchURL = useLocation().search
    // CURRENT URL
    const currentURL = useLocation().pathname

    const timeStatus = (startTime, endTime) => {
        const time = new Date(startTime).getTime()
        const end = new Date(endTime).getTime()
        const now = new Date().getTime()

        if(now < time) return startTime
        if(now >= time) {
            if(now < end) return endTime
            else return 0
        }
    }

    const printStatus = () => {
        const auctionStatus = auctionDetailState.auctionDetail?.data?.autionStatus

        const start = new Date(auctionDetailState.auctionDetail?.data?.startAtPeriod).getTime()
        const end = new Date(auctionDetailState.auctionDetail?.data?.endAtPeriod).getTime()
        const now = new Date().getTime()

        if(auctionStatus === "ON GOING") {
            let str = 'Sedang Berlangsung'
            let color = colors.green[600];
            if(now < start) {
                str = 'Menunggu Dimulai'
                color = colors.orange[600]
            } 
            return (
                <Typography
                    variant="body2"
                    sx={{ marginBottom: downMediumScreen ? "6px" : "12px", textTransform: "uppercase" }}
                    style={downMediumScreen ? fontPreset.body16Bold : fontPreset.body18Bold}
                    color={color}
                >
                    {str}
                </Typography>
            )
        } else if(auctionStatus === "DONE") {
            return (
                <Typography
                    variant="body2"
                    sx={{ marginBottom: downMediumScreen ? "6px" : "12px", textTransform: "uppercase" }}
                    style={downMediumScreen ? fontPreset.body16Bold : fontPreset.body18Bold}
                    color={colors.red[700]}
                >
                    Sudah Selesai
                </Typography>
            )
        } else {
            return (
                <Typography
                    variant="body2"
                    sx={{ marginBottom: downMediumScreen ? "6px" : "12px", textTransform: "uppercase" }}
                    style={downMediumScreen ? fontPreset.body16Bold : fontPreset.body18Bold}
                    color={colors.grey[700]}
                >
                    Belum Dimulai
                </Typography>
            )
        }
        
    }

    const IconAndDesc = ({ icon, desc }) => {
        return (
            <Box display='flex' gap='0 1rem' mt={1} alignItems='center'>
                <Box sx={{ padding: '.1rem 0' }}>
                    { icon }
                </Box>
                <Box>
                    <Typography variant='body2' align='justify'>
                        { desc }
                    </Typography>
                </Box>
            </Box>
        )
    }

    const handleClickDownloadApp = (platform) => {
        captureEventGAWithAction({
            category: "Hit Button",
            action: `Go To ${platform}`
        })
        // PIXEL
        captureEventPixel({
            eventName: `Go To ${platform}`,
            params: { category: "Hit Button" }
        })
    }

    const trackClickProfile = ({ auctionHallName, auctionId }) => () => {
        // GOOGLE ANALYTICS
        captureEventGAWithParams({
            eventName: 'Klik Lihat Balai Lelang',
            params: { auctionHallName, auctionId }
        })
        // SAVE EVENT TO DB
        captureEventToDB({
            event: { 
                category: "Action",
                eventName: "Klik Lihat Balai Lelang",
                auctionHallName,
                auctionId
            }
        })
    }

    useEffect(() => {
        dispatch(getAuctionDetail({ auctionId: params.auctionId }))
    }, [])

    return (
        <Container sx={{ padding: { xs: '1rem', sm: '1.5rem', md: '2rem' } }}>
            {   auctionDetailState.loading ? 
                    <AuctionDetailSkeleton /> :
                auctionDetailState.error ? 
                    <div>Error, Something Went Wrong...</div> :
                auctionDetailState.success ? 
                    auctionDetailState.auctionDetail.success ?
                        <>
                            <Helmet>
                                <title> { auctionDetailState.auctionDetail.data.auctionName } - DjuBli </title>
            
                                <meta name="description" content="Jual Mobil bekas, kondisi terbaik, beli, jual, cek harga, cek kondisi, cari Mobil baru, Mobil bekas murah, mpv, suv, pasar Mobil bekas Indonesia" />
                                {/* <meta property="og:title" content={`${ auctionDetailState.auctionDetail.data.auctionName } - DjuBli`} /> */}
                                <meta property="og:description" content="Jual Mobil bekas, kondisi terbaik, beli, jual, cek harga, cek kondisi, cari Mobil baru, Mobil bekas murah, mpv, suv, pasar Mobil bekas Indonesia" />
                                <meta property="og:site_name" content="Jual Beli Mobil Bekas" />
                                <meta property="og:url" content={window.location.href} />
                                <link rel="canonical" href={`https://www.djubli.com${currentURL}`} />
                            </Helmet>

                            <Grid container spacing={{ xs: 1, md: 3 }}>
                                {/* PROFILE NAME */}
                                <Grid item xs={12}>
                                    <Box display='flex' gap={{ xs: '1rem', md:'2rem 3rem' }} p={{ xs: '.5rem', md: '0 0 2rem 0' }} alignItems='center'>
                                        {/* DESC BOX */}
                                        <Box display='flex' flexDirection='column' flexGrow='1'>
                                            <Box display='flex' justifyContent='space-between' alignItems='center' py={2}>
                                                {/* USERNAME */}
                                                <Box>
                                                    <Typography
                                                        variant='h4' 
                                                        component='h1'
                                                        fontSize={{ xs: '1.25rem', sm: '1.75rem', md: '2.125rem' }}
                                                    >
                                                        { auctionDetailState.auctionDetail.data?.auctionName ?? "Auction Name" }
                                                    </Typography>
                                                    <RouteLink
                                                        component="button"
                                                        variant="body2"
                                                        to={`/produk/djubli-lelang/balai-lelang/${auctionDetailState.auctionDetail.data?.auctionHall?.id}`}
                                                        style={{ color: colorPalette.primary }}
                                                        onClick={
                                                            trackClickProfile({
                                                                auctionHallName: auctionDetailState.auctionDetail.data?.auctionHall?.auctionHallName,
                                                                auctionId: auctionDetailState.auctionDetail.data?.auctionHall?.id
                                                            })
                                                        }
                                                    >
                                                        <Typography 
                                                            variant='body2'
                                                            fontSize={{ xs: '.75rem', md: '1rem' }}
                                                            sx={{ marginTop: ".25rem" }}
                                                        >
                                                            { auctionDetailState.auctionDetail.data?.auctionHall?.auctionHallName ?? "Auction Hall Name" }
                                                        </Typography>
                                                    </RouteLink>
                                                </Box>

                                                {/* SHARE DIALOG */}
                                                <ShareButton
                                                    dealerName={ auctionDetailState.auctionDetail.data?.auctionName ?? "Auction Name" }
                                                    section='Auction Detail Schedule'
                                                />
                                            </Box>

                                            {/* DEALER INFO MEDIUM SCREEN */}
                                            <Box>
                                                <Grid container rowSpacing={2}>
                                                    <Grid item xs={12} md={6}>
                                                        { 
                                                            IconAndDesc({ 
                                                                icon: <LocationOnIcon />,
                                                                desc: auctionDetailState.auctionDetail.data?.auctionLocation ?? "Auction Location"
                                                            }) 
                                                        }

                                                        { 
                                                            IconAndDesc({ 
                                                                icon: <TimeToLeaveIcon />,
                                                                desc: `${auctionDetailState.auctionDetail.data?.auctionCars.length} Mobil` ?? "Total Cars"
                                                            })
                                                        }

                                                        { 
                                                            IconAndDesc({ 
                                                                icon: <AccessTimeIcon />,
                                                                desc: `${ changeDateFormat(new Date(auctionDetailState.auctionDetail.data?.startAtPeriod)) }, ${ changeTimeFormat(new Date(auctionDetailState.auctionDetail.data?.startAtPeriod)) } - ${ changeDateFormat(new Date(auctionDetailState.auctionDetail.data?.endAtPeriod)) }, ${ changeTimeFormat(new Date(auctionDetailState.auctionDetail.data?.endAtPeriod)) }`
                                                            })
                                                        }
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        { printStatus() }

                                                        <AuctionCountdownCard
                                                            auctionDate={
                                                                timeStatus(auctionDetailState.auctionDetail.data?.startAtPeriod, auctionDetailState.auctionDetail.data?.endAtPeriod)
                                                            }
                                                        />

                                                        <Box sx={{ marginTop: downMediumScreen ? "8px" : "14px", display: "flex", columnGap: "8px" }}>
                                                            {   timeStatus(auctionDetailState.auctionDetail.data?.startAtPeriod, auctionDetailState.auctionDetail.data?.endAtPeriod) === 0 ?
                                                                    <Button
                                                                        variant="contained"
                                                                        onClick={() => { 
                                                                            handleOpenDialog({ title: "Hasil Lelang", body: "Kamu bisa melihat hasil lelang menggunakan aplikasi DjuBli. Download Sekarang!" })
                                                                        }}
                                                                        fullWidth
                                                                    >
                                                                        Lihat Hasil Lelang
                                                                    </Button> :
                                                                // ON GOING
                                                                    <Box sx={{ flexGrow: 1 }}>
                                                                        <Box sx={{ display: "flex", columnGap: "8px" }}>
                                                                            <Box sx={{ flexGrow: 1 }}>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    onClick={handleOpenDialogBuyToken}
                                                                                    fullWidth
                                                                                >
                                                                                    Beli Token
                                                                                </Button>
                                                                            </Box>
                                                                            <Box sx={{ flexGrow: 3 }}>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    onClick={() => {
                                                                                        handleOpenDialog({})
                                                                                    }}
                                                                                    fullWidth
                                                                                >
                                                                                    Ikuti Lelang
                                                                                </Button>
                                                                            </Box>

                                                                            <DjubliDialog
                                                                                open={openDialogBuyToken}
                                                                                handleClose={handleCloseDialogBuyToken}
                                                                                title={'Cara Beli Token'}
                                                                                notFullScreen
                                                                                body={
                                                                                    <Box>
                                                                                        { AUCTION_BUY_TOKEN_STEP.map((step) => (
                                                                                            <Typography
                                                                                                key={step.step}
                                                                                                variant="body2"
                                                                                                sx={downMediumScreen ? fontPreset.body12Reg : fontPreset.body14Reg}
                                                                                            >
                                                                                                { step.step }. { step.desc }
                                                                                            </Typography>
                                                                                        )) }
                                                                                    </Box>
                                                                                }
                                                                                actions={<div></div>}
                                                                            />
                                                                        </Box>

                                                                        {   auctionDetailState.auctionDetail.data?.auctionScheduleType === "ONSITE" ?
                                                                                <Button
                                                                                    variant="contained"
                                                                                    sx={{ marginTop: "8px" }}
                                                                                    fullWidth
                                                                                    onClick={() => {
                                                                                        handleOpenDialog({})
                                                                                    }}
                                                                                    endIcon={<ChevronRightIcon />}
                                                                                >
                                                                                    Masuk ke Bid Room
                                                                                </Button> :
                                                                            // TIMED LELANG
                                                                                <Button
                                                                                    variant="contained"
                                                                                    sx={{ marginTop: "8px" }}
                                                                                    fullWidth
                                                                                    LinkComponent={Link}
                                                                                    href={`/produk/djubli-lelang/bid/${params.auctionId}`}
                                                                                    endIcon={<ChevronRightIcon />}
                                                                                >
                                                                                    Masuk ke Bid Room
                                                                                </Button>
                                                                        
                                                                        }
                                                                    </Box>
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider variant='fullWidth' sx={{ marginY: 2 }} />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography 
                                    variant='body2'
                                    fontSize={{ xs: '.875rem', md: '1rem' }}
                                    sx={{ marginBottom: 2 }}
                                >
                                    Daftar Mobil
                                </Typography>
                            </Grid>

                            {   auctionDetailState.auctionDetail?.data?.auctionCars?.length > 0 ?
                                    <Grid item xs={12}>
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            {/* CARD MOBIL */}
                                            {auctionDetailState.auctionDetail?.data?.auctionCars?.map((val, index) => (
                                                <Grid item xs={12} sm={6} md={4} lg={3} key={val.id}>
                                                    <CarCard
                                                        key={val.id}
                                                        index={index}
                                                        data={val.car}
                                                        section={'auction_car'}
                                                        auctionData={val}
                                                        disableHoverActions={true}
                                                        disableScale={true}
                                                    />
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid> :
                                // NO CARS
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{ 
                                                bgcolor: colors.grey[300],
                                                height: "260px",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <p style={downMediumScreen ? fontPreset.body14Lig : fontPreset.body16Lig}>
                                                Belum ada mobil terdaftar dalam lelang.
                                            </p>
                                        </Box> 
                                    </Grid>
                            }
                        </> :
                    // NOT FOUND
                        <div style={{ paddingTop: downMediumScreen ? "40px" : "60px" }}>
                            <ResultNotFound
                                title ={"Lelang tidak ditemukan"}
                                message ={"Harap hubungi djubli atau lihat lelang lainnya disini."}
                            />
                        </div> :
                // ELSE STATE
                    <div>Something went wrong...</div>
            }

            <DjubliDialog
                open={openDialog}
                handleClose={handleCloseDialog}
                title={dialogContent.title}
                body={
                    <div >
                        <LazyLoadImage 
                            alt={`Djubli Auction`}
                            src={`/images/djubli_auction/auction-online.png`}
                            effect="opacity"
                            width={'100%'}
                        />

                        <Typography
                            component={"h1"}
                            style={downMediumScreen ? fontPreset.body14Reg : fontPreset.body16Reg}
                            align="center"
                        >
                            { dialogContent.body }
                        </Typography>

                        <div 
                            style={{ display: "flex", justifyContent: "center", marginTop: "24px", columnGap: "2px" }}
                        >
                            <Link
                                href="https://play.google.com/store/apps/details?id=com.djubli"
                                target='_blank'
                                rel="noopener noreferrer"
                                onClick={() => {
                                    handleClickDownloadApp("play store")
                                }}
                            >
                                <LazyLoadImage
                                    alt={`Djubli Play Store`}
                                    src={`/images/download_logo/play-store-logo.png`}
                                    effect="opacity"
                                    height={'41px'}
                                    width={'130px'}
                                />
                            </Link>
                            
                            <Link
                                href="https://apps.apple.com/id/app/djubli/id1588867080"
                                target='_blank'
                                rel="noopener noreferrer"
                                onClick={() => {
                                    handleClickDownloadApp("app store")
                                }}
                            >
                                <LazyLoadImage
                                    alt={`Djubli App Store`}
                                    src={`/images/download_logo/app-store-logo.png`}
                                    effect="opacity"
                                    height={'41px'}
                                    width={'130px'}
                                />
                            </Link>
                        </div>
                    </div>
                }
                actions={<div></div>}
                maxWidth={"xs"}
                fullWidth
                notFullScreen
            />

            {/* <DjubliDialog
                open={openNotesDialog}
                handleClose={handleCloseNotesDialog}
                title={'KETERANGAN PENTING (WAJIB UNTUK DIBACA)'}
                body={
                   <div style={{ display: "flex", rowGap: "4px", flexDirection: "column" }}>
                        {   auctionNotes.map((notes, index) => (
                                <div style={{ display: 'flex', columnGap: '8px' }}>
                                    <div><p style={{ margin: "0" }}>{ index + 1}</p></div>
                                    <div><p style={{ margin: "0" }}>{ notes }</p></div>
                                </div>
                            ))
                        }
                   </div>
                }
                actions={<div></div>}
                maxWidth={"sm"}
                fullWidth
                notFullScreen
            /> */}
        </Container>
    )
}

export default AuctionDetail